import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";

/**
 * 登录区域的共用属性和方法
 * @type {{}}
 */
import _register from './register.vue';
import forgot from './forgot.vue';
export var loginMixins = {
  data: function data() {
    return {};
  },
  components: {},
  computed: {
    rules: function rules() {
      return {
        userName: [{
          required: true,
          message: this.$t('loginArea.userNameNotNull'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('loginArea.passwordNotNull'),
          trigger: 'blur'
        }],
        interest: [{
          required: true,
          type: 'boolean',
          message: this.$t('loginArea.legalNoticeNotNull'),
          trigger: 'change'
        }]
      };
    },
    //法律法规
    getDocUrl: function getDocUrl() {
      var root = "";

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      return root + "/static/yszc.html";
    },
    //服务条款
    getDocServiceUrl: function getDocServiceUrl() {
      var root = "";

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      return root + "/static/fwtk.html";
    }
  },
  methods: {
    //服务条款
    viewService: function viewService() {
      window.open(this.getDocServiceUrl);
    },
    //法律法规
    viewNotice: function viewNotice() {
      window.open(this.getDocUrl); //this.$emit('viewNotice')
    },
    register: function register() {
      var _this = this;

      var vm = this;
      var config = {
        loading: true,
        width: 700,
        render: function render(h) {
          return h("div", [h("h4", {
            style: {
              marginBottom: "15px"
            }
          }, _this.$t('loginArea.register')), h(_register, {
            ref: "registerRef",
            props: {
              $store: _this.$store,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this2 = this;

          this.buttonLoading = false;
          var reg = this.$refs.registerRef;

          var _reg$formData = _objectSpread({}, reg.formData),
              mobile = _reg$formData.mobile,
              code = _reg$formData.code,
              password = _reg$formData.password,
              org_code = _reg$formData.org_code,
              email = _reg$formData.email; //repeat_password


          var params = {
            mobile: mobile,
            code: code,
            password: password,
            org_code: org_code,
            email: email
          },
              callbak = function callbak(res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              _this2.$Message.success(msg);

              _this2.$Modal.remove();
            } else {
              _this2.$Message.error(msg);
            }
          };

          var submit = function submit() {
            vm.handleRegister(params).then(function (res) {
              callbak(res);
            });
          };

          this.$refs.registerRef.handleSubmit(submit);
        }
      };
      this.$Modal.confirm(config);
    },
    forgotPassword: function forgotPassword() {
      var _this3 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h("div", [h("h4", {
            style: {
              marginBottom: "15px"
            }
          }, vm.$t('loginArea.forgetPassword')), h(forgot, {
            ref: "forgotRef",
            props: {
              $store: _this3.$store,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this4 = this;

          this.buttonLoading = false;
          var reg = this.$refs.forgotRef;

          var _reg$formMoblie = _objectSpread({}, reg.formMoblie),
              mobile = _reg$formMoblie.mobile,
              code = _reg$formMoblie.code,
              password = _reg$formMoblie.password,
              org_code = _reg$formMoblie.org_code;

          var emailData = reg.formEmail,
              nameType,
              sendtype;

          var params,
              callbak = function callbak(res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              _this4.$Message.success(msg);

              _this4.$Modal.remove();
            } else {
              _this4.$Message.error(msg);
            }
          };

          if (reg.nameTabs == "name1") {
            sendtype = 2;
            params = {
              mobile: mobile,
              code: code,
              password: password,
              sendtype: sendtype
            };
            nameType = "formMoblie";
          } else {
            sendtype = 2;
            params = {
              mobile: emailData.email,
              code: emailData.code,
              password: emailData.password,
              sendtype: sendtype
            };
            nameType = "formEmail";
          }

          var submit = function submit() {
            vm.handleForgot(params).then(function (res) {
              callbak(res);
            });
          };

          this.$refs.forgotRef.handleSubmit(nameType, submit);
        }
      };
      this.$Modal.confirm(config);
    }
  }
};